//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {formatDate} from "../../../lib/date";
import util from '@/lib/util';

export default {
    name: "signIn",
    filters: {
        formatDate(time, type) {
            var date = new Date(time);
            if (type == 1) {
                return formatDate(date, 'yyyy-MM-dd');
            }
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    },
    data() {
        return {
            code: '',
            activity: {},
            signUpInfo: {},
            downloadUrl: util.ApiUrl + 'file/download/',
            show: false
        }
    },
    methods: {
        getSignUp() {
            abp.ajax.get('/api/services/app/Activity/GetSignUpRecordByCode?code=' + this.code).then(res => {
                this.signUpInfo = {};
                this.signUpInfo = res.data.result;
            }).finally(() => {

            })
        },
        onSignIn() {
            abp.ajax.post('/api/services/app/Activity/MSignIn?code=' + this.code).then(res => {
                // this.$toast.success("签到成功")
                this.getSignUp();
                this.show = true;
            }).finally(() => {

            })
        }
    },
    created() {
        this.code = this.$route.params.code
        this.getSignUp()
    }
}
